"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
/**
 * Quantity directive to render as many elements as quantity input instead of using *ngFor with arrays.
 * Directive has one input quantity and also give you index as context.
 */
var QuantityDirective = /** @class */ (function () {
    function QuantityDirective(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    QuantityDirective.ngTemplateGuard_quantity = function (dir, expr) {
        return true;
    };
    ;
    QuantityDirective.ngTemplateContextGuard = function (dir, ctx) {
        return true;
    };
    ;
    Object.defineProperty(QuantityDirective.prototype, "quantity", {
        set: function (quantity) {
            // to clear last content
            this.viewContainer.clear();
            // creates as many elements as quantity
            for (var i = 0; i < quantity; i++) {
                this.viewContainer.createEmbeddedView(this.templateRef, { index: i });
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], QuantityDirective.prototype, "quantity", null);
    QuantityDirective = __decorate([
        core_1.Directive({
            selector: '[quantity]'
        }),
        __metadata("design:paramtypes", [core_1.TemplateRef, core_1.ViewContainerRef])
    ], QuantityDirective);
    return QuantityDirective;
}());
exports.QuantityDirective = QuantityDirective;
//# sourceMappingURL=quantity.directive.js.map